import { Component, ElementRef, Input, OnInit, TemplateRef, ViewChild, HostListener } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SwiperOptions } from 'swiper';
import { MyLibraryService } from './my-library.service';
import { trigger, transition, style, animate, state } from '@angular/animations';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SharedService } from '../../../../shared/shared.service';
import { ProgramPageService } from '../program-page/program-page.service';
import { MdbTabChange } from 'mdb-angular-ui-kit/tabs/tabs.component';
import { MdbTabsComponent } from 'mdb-angular-ui-kit/tabs';
import { MatSidenav } from '@angular/material/sidenav';
import { MatSnackBar } from '@angular/material/snack-bar';
import { OrganizationService } from '../../../obsolete/components/organization/organization.service';
import { UsersService } from 'src/app/modules/management/components/tabs/components/users/users.service';
import { PostHogService } from 'src/app/shared/services/posthog.service';
import { POSTHOG_EVENT_REGISTER_INTEREST } from 'src/app/shared/constants/posthog-events.constants';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
	selector: 'app-my-library',
	templateUrl: './my-library.component.html',
	styleUrls: ['./my-library.component.scss'],
	animations: [
		trigger('widthGrow', [
			state('closed', style({
				width: 0,
			})),
			state('open', style({
				width: 760,
				maxWidth: '100%'

			})),
			transition('* => *', animate(150))
		]),
		trigger('widthGrowOpacity', [
			state('closed', style({
				width: 0,
			})),
			state('open', style({
				width: 10000,
			})),
			// transition('* => *', animate(10))
		]),

	]
})
export class MyLibraryComponent implements OnInit {
	showAll: any;
	showallsubcat: boolean = false;
	subcatName: any;
	selectedsubcatName: any;
	selectedCatName: any;
	showSubCategories: any;
	activeTab: any;
	@ViewChild('sidenav') sidenav!: MatSidenav;
	activeSubTabIndex: number = 0;
	currentPrograms: any;
	state = "closed";
	allCourse: any;
	allProgram: any;
	@ViewChild('tabs') tabs!: MdbTabsComponent;
	@ViewChild('cardElement') cardElement!: ElementRef;
	@ViewChild('cardEl') cardEl!: ElementRef;
	@ViewChild('editModal')
	editModal!: TemplateRef<any>;
	showPopup!: Boolean;
	selectedCategId: any;
	headerTitle: any = ' ';
	categories: any;
	cardImageHeight: number = 0;
	config: SwiperOptions = {
		slidesPerView: 3,
		spaceBetween: 50,

		navigation: true,
		pagination: { clickable: true },
		scrollbar: { draggable: true },
	};

	math = Math;
	slides$ = new BehaviorSubject<string[]>(['']);
	images = [944, 1011, 984].map((n) => `https://picsum.photos/id/${n}/900/500`);
	programData: any;
	currentEnrolments: any;
	isCompleted: any;
	achievePrograms: any;
	blockLoader: string = "blockLoader";
	activeProgramData: any = [];
	activeSubProgram: any = [];
	programDetails: any;
	activePrograms: any = [];
	@ViewChild('subTabs') subTabs: any;
	@ViewChild('categoryTabs') categoryTabs: any;
	organizationId: any;
	initialLoad: boolean = true;
	programLoader = "programLoader";
	orgData: any;
	userEnrollments: any = [];
	userId: any = "";
	notAllowedPrograms: any = [];
	registeredPrograms: any = [];
	currentNotAllowedPrograms: any = [];
	user: any;
	@HostListener('window:resize', ['$event'])
	onResize(event: Event): void {
		const windowWidth = window.innerWidth;
		if (windowWidth < 800) {
			this.mobileMenu();
		}
	}

	ngAfterViewInit() {
		// this.calculateCardHeight();
		this.calculateTabCardImageHeight();
	}

	constructor(
		private myLibraryService: MyLibraryService,
		private router: Router,
		private sharedService: SharedService,
		private spinner: NgxSpinnerService,
		private programPageService: ProgramPageService,
		private snackbar: MatSnackBar,
		private organizationService: OrganizationService,
		private usersService: UsersService,
		private posthog: PostHogService,
		private deviceDetectorService: DeviceDetectorService
	) {
		this.organizationId = localStorage.getItem('orgId');
		this.userId = localStorage.getItem('userId');
		this.usersService.getUserDetails(this.userId)
			.then((res: any) => {
				console.log('res.organizationId: ', res);
				this.organizationId = res.organisationId; // or res.data.organizationId
				console.log('getUserDetails -> this.organizationId: ', this.organizationId);
				localStorage.setItem('orgId', this.organizationId);
			})
			.catch((err: any) => console.error('Error fetching user:', err));
		this.sharedService.activePrograms$.subscribe(activePrograms => {
			// console.log(activePrograms);
			this.activePrograms = activePrograms;
		});

		const windowWidth = window.innerWidth;
		if (windowWidth < 800) {
			this.selectedsubcatName = "All";
		}
	}

	async ngOnInit() {
		this.getCategories();
		this.getRegisterInterest();
		this.slides$.next(
			Array.from({ length: 600 }).map((el, index) => `Slide ${index + 1}`)
		);
		this.userId = localStorage.getItem('userId');

		// get orgId either from localStorage or fetch
		this.organizationId = localStorage.getItem('orgId');
		if (!this.organizationId) {
			const res: any = await this.usersService.getUserDetails(this.userId);
			this.organizationId = res.organisationId;
			localStorage.setItem('orgId', this.organizationId);
		}


		await this.spinner.show("blockLoader");
		this.orgData = await this.organizationService.getOrganizationData(this.organizationId);
		if (!this.organizationId) {
			this.orgData = {};
		}
		this.userEnrollments = await this.usersService.getUserEnrollmentIds(this.userId);
		// console.log(this.userEnrollments);
		await this.spinner.hide("blockLoader");
		this.getProgramsData();
		this.popupVar();
		// this.calculateCardHeight();
		this.mobileMenu();

		if (this.orgData && !this.orgData.hiddenPrograms) {
			this.orgData.hiddenPrograms = [];
		}
		await this.getUserDetails();
	}

	async getUserDetails() {
		let userId: any = localStorage.getItem('userId');
		if (userId) this.user = await this.usersService.getUserDetails(userId);
		// console.log('user...', this.user)
	}

	getProgramsData() {
		this.myLibraryService.getPrograms().subscribe(async data => {
			let allProgram: any = data;
			this.programData = [];
			let programs = [];
			this.notAllowedPrograms = [];
			this.currentPrograms = [];
			for (let program of allProgram) {
				for (let i = 0; i < this.categories.length; i++) {
					if (this.categories[i].id === program.category.id) {
						if (this.categories[i].visible) {
							for (let j = 0; j < this.categories[i].subCategories.length; j++) {
								if (this.categories[i].subCategories[j].id === program.subCategory.id) {
									if (this.categories[i].subCategories[j].visible && this.orgData && !this.orgData.hiddenPrograms.includes(program.id)) {
										programs.push(program);
										break;
									}
								}
							}
							break;
						}
					}
				}

			}

			if (this.organizationId) {
				for (let i = 0; i < programs.length; i++) {
					if (this.orgData && this.orgData.hiddenPrograms.includes(programs[i].id) || !this.hasRoleBasedAccess(programs[i].id)) {
						continue;
					} else if (this.orgData.allowedPrograms.includes(programs[i].id) && this.hasRoleBasedAccess(programs[i].id)) {
						this.programData.push(programs[i]);
					} else {
						this.notAllowedPrograms.push(programs[i]);
					}
				}
			} else {
				for (let i = 0; i < programs.length; i++) {
					this.programData.push(programs[i]);
				}
			}

			this.programData = this.removeDuplicates(this.programData);
			this.notAllowedPrograms = this.removeDuplicates(this.notAllowedPrograms);

			for (let i = 0; i < this.notAllowedPrograms.length; i++) {
				let index = this.registeredPrograms.findIndex((el: any) => (el.programId === this.notAllowedPrograms[i].id) && (el.userId === this.userId));
				// console.log('index', index);
				if (index !== -1) {
					this.notAllowedPrograms[i].isRegistered = true;
				} else {
					this.notAllowedPrograms[i].isRegistered = false;
				}
			}

			this.sortArray(this.notAllowedPrograms);
			this.sortProgramData();
			this.currentPrograms = this.programData;
			// console.log(this.currentPrograms);

			await this.spinner.show("programLoader");
			this.initialLoad = true;
			await this.checkEnrollments();
			this.initialLoad = false;
			await this.spinner.hide("programLoader");
		});
	}

	async checkEnrollments() {
		for (let program of this.programData) {
			// console.log(program);
			// program.isUserEnrolled = await this.programPageService.isUserEnrolled(program.id, userId);
			program.isUserEnrolled = this.isUserEnrolled(program.id);
			if (program.isUserEnrolled) {
				program.progress = this.getProgramProgress(program.id);
			}
		}
	}

	getOrgId() {
		return localStorage.getItem('orgId');
	}

	getGroupId() {
		return localStorage.getItem('groupId');
	}

	async getAllCourse() {
		const orgId = this.getOrgId();
		// this.allCourse = await this.myLibraryService.getAllCourse(orgId);
		// console.log('this.allCourse',this.allCourse);
	}

	getUser() {
		return localStorage.getItem('username');
	}

	changeState(programDetails: any): void {
		// console.log(programDetails);
		this.programDetails = programDetails;
		if (programDetails === 'cross') {
			this.programDetails = ''
		}

		(this.state == "closed") ? this.state = "open" : this.state = "closed";
		(this.state == "closed") ? this.state = "open" : this.state = "closed";
		window.scroll({
			top: 0,
			left: 0,
			behavior: 'smooth'
		});

		if (this.state == "closed") {
			this.state = "open"
			document.body.style.overflow = 'hidden';
		} else {
			this.state = "closed"
			document.body.style.overflow = 'auto';
		}
	}

	async launchProgramAfterCheck() {
		const email = localStorage.getItem('username');
		if (this.organizationId) {
			if (this.orgData.allowedPrograms) {
				if (this.orgData.allowedPrograms.includes(this.programDetails.id) && this.hasRoleBasedAccess(this.programDetails.id)) {
					await this.launchProgram();
				} else {
					this.snackbar.open("This program is currently locked.", "", {
						duration: 6000
					});
				}
			} else {
				await this.launchProgram();
			}
		} else if (email === 'igniteadmin1@example.com' || email === 'igniteadmin2@example.com' || email === 'devadmin1@example.com' || email === 'devadmin2@example.com' || email === 'terry@terryhawkins.com') {
			// super admin; can launch any program
			await this.launchProgram();
		}
	}

	async launchProgram() {
		// console.log('working', this.programDetails)
		const progressId = this.userId + "_" + this.programDetails?.id;

		if (!this.programDetails.isUserEnrolled) {
			await this.spinner.show("blockLoader");
			delete this.programDetails['isUserEnrolled'];
			if (this.programDetails['progress']) {
				delete this.programDetails['progress'];
			}
			await this.programPageService.saveLaunchData(this.programDetails);
			await this.spinner.hide("blockLoader");
		}

		this.router.navigate(['programs'], {
			state: {
				progressId
			}
		});
	}

	async launchProgramByCardAfterCheck(programDetails: any) {
		const email = localStorage.getItem('username');
		if (this.organizationId) {
			if (this.orgData.allowedPrograms) {
				if (this.orgData.allowedPrograms.includes(programDetails.id) && this.hasRoleBasedAccess(programDetails.id)) {
					await this.launchProgramByCard(programDetails);
				} else {
					this.snackbar.open("This program is currently locked.", "", {
						duration: 6000
					});
				}
			} else {
				await this.launchProgramByCard(programDetails);
			}
		} else if (email === 'igniteadmin1@example.com' || email === 'igniteadmin2@example.com' || email === 'devadmin1@example.com' || email === 'devadmin2@example.com' || email === 'terry@terryhawkins.com') {
			// super admin; can launch any program
			await this.launchProgramByCard(programDetails);
		}
	}

	async launchProgramByCard(programDetails: any) {
		// console.log('working', programDetails.id)
		const progressId = this.userId + "_" + programDetails.id;

		if (!programDetails.isUserEnrolled) {
			await this.spinner.show("blockLoader");
			delete programDetails['isUserEnrolled'];
			if (programDetails['progress']) {
				delete programDetails['progress'];
			}
			await this.programPageService.saveLaunchData(programDetails);
			await this.spinner.hide("blockLoader");
		}

		this.router.navigate(['programs'], {
			state: {
				progressId
			}
		});
	}

	getLearningHrs(sections: any) {
		let totalLearningHrs = this.getTotalLearningHrs(sections);
		return this.sharedService.secondsToHours(totalLearningHrs);
	}

	getTotalLearningHrs(sections: any) {
		let learningDuration = 0;

		if (sections?.length >= 1) {
			for (let section of sections) {
				if (section.type === 'menu') {
					learningDuration += this.getTotalLearningHrs(section.menu);
				} else if (section.type === 'video') {
					for (let topic of section.metadata.topics) {
						learningDuration += Number(topic.videoDuration);
					}
				}
			}
		}

		return learningDuration;
	}

	getSectionNos(sections: any) {
		return this.getTotalSectionNos(sections);
	}

	getTotalSectionNos(sections: any) {
		let sectionCount = 0;

		if (sections?.length >= 1) {
			for (let section of sections) {
				if (section.type === 'menu') {
					sectionCount += this.getTotalSectionNos(section.menu);
				} else {
					sectionCount += 1;
				}
			}
		}

		return sectionCount;
	}

	popupVar() {
		// console.log('proggg')
		if (this.activePrograms.length === 0) {
			//   console.log('proggg')
			this.showPopup = true;
		}
	}

	hidePopup() {
		this.showPopup = false;
	}

	async onTabChange(ev: MdbTabChange) {
		// console.log('ev.tab.title', ev.tab.title)
		const clickedTabIndex = ev.index;
		// Update the activeSubTabIndex based on the clicked tab index
		this.activeSubTabIndex = clickedTabIndex;

		let activeTab = ev.tab.title;
		this.selectedCatName = activeTab;
		if (this.selectedCatName !== "All") {
			this.selectedsubcatName = "All";
		} else {
			this.selectedsubcatName = "";
		}
		if (activeTab === 'All') {
			// console.log('All', this.programData);
			this.currentPrograms = this.programData;
			this.currentPrograms = this.removeDuplicates(this.currentPrograms);
		} else {
			this.currentPrograms = []
			this.activeProgramData = [];
			this.activeSubProgram = [];
			this.currentNotAllowedPrograms = [];
			let currentAllPrograms = [];
			this.sortProgramData();

			this.programData.filter((item: any) => {
				if (item?.category?.name === activeTab) {
					// console.log('item', item)
					this.activeProgramData.push(item);
				}
			});
			this.activeProgramData = this.removeDuplicates(this.activeProgramData);

			await this.spinner.show("blockLoader");
			const selectedCategory: any = await this.myLibraryService.getCategoryByName(activeTab);
			// console.log('selectedCategory', selectedCategory)
			// console.log('selectedCategory?.subCategories[0]?.name', selectedCategory?.subCategories[0]?.name)
			currentAllPrograms = await this.myLibraryService.getFirstCurrentTabProgram(selectedCategory.id, "");
			if (this.orgData) {
				currentAllPrograms = currentAllPrograms.filter((program: any) => {
					return !this.orgData.hiddenPrograms.includes(program.id);
				});
			}
			for (let program of currentAllPrograms) {
				// program.isUserEnrolled = await this.programPageService.isUserEnrolled(program.id, userId);
				program.isUserEnrolled = this.isUserEnrolled(program.id);
				if (program.isUserEnrolled) {
					program.progress = this.getProgramProgress(program.id);
				}
			}

			if (this.organizationId) {
				for (let i = 0; i < currentAllPrograms.length; i++) {
					if (this.orgData && this.orgData.hiddenPrograms.includes(currentAllPrograms[i].id) || !this.hasRoleBasedAccess(currentAllPrograms[i].id)) {
						continue;
					} else if (this.orgData.allowedPrograms.includes(currentAllPrograms[i].id) && this.hasRoleBasedAccess(currentAllPrograms[i].id)) {
						this.currentPrograms.push(currentAllPrograms[i]);
					} else {
						this.currentNotAllowedPrograms.push(currentAllPrograms[i]);
					}
				}
			} else {
				for (let i = 0; i < currentAllPrograms.length; i++) {
					this.currentPrograms.push(currentAllPrograms[i]);
				}
			}

			for (let i = 0; i < this.currentNotAllowedPrograms.length; i++) {
				let index = this.registeredPrograms.findIndex((el: any) => (el.programId === this.currentNotAllowedPrograms[i].id) && (el.userId === this.userId));
				// console.log('index', index);
				if (index !== -1) {
					this.currentNotAllowedPrograms[i].isRegistered = true;
				} else {
					this.currentNotAllowedPrograms[i].isRegistered = false;
				}
			}

			this.currentPrograms = this.removeDuplicates(this.currentPrograms);
			this.currentNotAllowedPrograms = this.removeDuplicates(this.currentNotAllowedPrograms);
			this.sortArray(this.currentNotAllowedPrograms);
			this.sortArray(this.currentPrograms);

			// console.log('selectedFirstCurrentTabPrograms', this.currentPrograms)
			await this.spinner.hide("blockLoader");
			// this.subTabs.setActiveTab(0);
		}
	}

	async onSubTabChange(activeTab: MdbTabChange, categId: any) {
		this.currentPrograms = [];
		this.activeSubProgram = [];
		this.currentNotAllowedPrograms = [];
		this.selectedsubcatName = activeTab;

		if (this.selectedCatName === "All" && this.selectedsubcatName === "All") {
			this.selectedsubcatName = "";
		}
		this.activeProgramData.filter((data: any) => {
			if (data?.subCategory?.name === activeTab) {
				this.activeSubProgram.push(data);
			}
		});
		this.sortProgramData();
		await this.getCurrentPrograms(categId, activeTab);
	}

	getCategories() {
		this.myLibraryService.getCategories().subscribe(data => {
			// console.log('data', data)
			this.categories = data;
			this.categories.sort((catA: any, catB: any) => {
				if (catA.order == undefined) {
					catA.order = 100000;
				}

				if (catB.order == undefined) {
					catB.order = 100000;
				}

				if (catA.order < catB.order) {
					return -1;
				} else if (catB.order < catA.order) {
					return 1;
				}

				return 0;
			});
			console.log('categories', this.categories);
		});
	}

	async getCurrentPrograms(categId: any, subcategName: any) {
		this.calculateTabCardImageHeight()
		await this.spinner.show("blockLoader");
		let currentAllPrograms = [];
		this.currentNotAllowedPrograms = [];
		this.currentPrograms = [];
		// console.log('categId', categId);
		// console.log('subcategName', subcategName);
		currentAllPrograms = await this.myLibraryService.getCurrentPrograms(categId, subcategName);
		// console.log(currentAllPrograms);
		if (this.orgData) {
			currentAllPrograms = currentAllPrograms.filter((program: any) => {
				return !this.orgData.hiddenPrograms.includes(program.id);
			});
		}

		for (let program of currentAllPrograms) {
			// program.isUserEnrolled = await this.programPageService.isUserEnrolled(program.id, userId);
			program.isUserEnrolled = this.isUserEnrolled(program.id);
			if (program.isUserEnrolled) {
				program.progress = this.getProgramProgress(program.id);
			}
		}

		if (this.organizationId) {
			for (let i = 0; i < currentAllPrograms.length; i++) {
				if (this.orgData && this.orgData.hiddenPrograms.includes(currentAllPrograms[i].id) || !this.hasRoleBasedAccess(currentAllPrograms[i].id)) {
					continue;
				} else if (this.orgData.allowedPrograms.includes(currentAllPrograms[i].id) && this.hasRoleBasedAccess(currentAllPrograms[i].id)) {
					this.currentPrograms.push(currentAllPrograms[i]);
				} else {
					this.currentNotAllowedPrograms.push(currentAllPrograms[i]);
				}
			}
		} else {
			for (let i = 0; i < currentAllPrograms.length; i++) {
				this.currentPrograms.push(currentAllPrograms[i]);
			}
		}

		for (let i = 0; i < this.currentNotAllowedPrograms.length; i++) {
			let index = this.registeredPrograms.findIndex((el: any) => (el.programId === this.currentNotAllowedPrograms[i].id) && (el.userId === this.userId));
			// console.log('index', index);
			if (index !== -1) {
				this.currentNotAllowedPrograms[i].isRegistered = true;
			} else {
				this.currentNotAllowedPrograms[i].isRegistered = false;
			}
		}

		this.currentPrograms = this.removeDuplicates(this.currentPrograms);
		this.currentNotAllowedPrograms = this.removeDuplicates(this.currentNotAllowedPrograms);
		this.sortArray(this.currentPrograms);
		this.sortArray(this.currentNotAllowedPrograms);
		// console.log(this.currentPrograms);

		// console.log('currentAllPrograms', currentAllPrograms);
		// console.log('currentPrograms', this.currentPrograms);

		await this.spinner.hide("blockLoader");
	}

	calculateCardHeight(): any {
		// console.log('sdfghj')
		if (this.cardElement) {
			const width = this.cardElement.nativeElement.offsetWidth;
			return width;
		}
		return 0;
	}

	calculateTabCardImageHeight() {
		if (this.cardEl) {
			this.cardImageHeight = this.cardEl.nativeElement.offsetWidth;
			return this.cardImageHeight;
		}
	}

	getFormattedCourseTime(courseTime: any) {
		return this.sharedService.getFormattedCourseTime(courseTime);
	}

	sortProgramData() {
		if (this.programData && this.programData.length >= 1) {
			this.programData.sort((a: any, b: any) => {
				const nameA = a.name?.toUpperCase();
				const nameB = b.name?.toUpperCase();

				if (nameA < nameB) {
					return -1;
				}
				if (nameA > nameB) {
					return 1;
				}
				return 0;
			});
		}
	}

	toggleSidenav() {
		this.sidenav.toggle();
	}

	async applySubcategories() {
		if (!this.showAll) {
			// console.log('!this.showAll')
			this.showAll = false;
			this.showallsubcat = false;
			// console.log('showAll', this.showAll)
			await this.spinner.show("blockLoader");
			// console.log('activeTab', this.activeTab)
			this.currentPrograms = [];
			this.activeSubProgram = [];
			// console.log(this.activeTab, 'activeSUBTab');
			this.activeProgramData.filter((data: any) => {
				if (data?.subCategory?.name === this.activeTab) {
					this.activeSubProgram.push(data);
				}
			});
			this.activeSubProgram = this.removeDuplicates(this.activeSubProgram);
			this.sortProgramData()
			await this.spinner.hide("blockLoader");

			if (this.activeTab === "All") {
				this.selectedsubcatName = "All";
			}
			// console.log(this.selectedCatName);
			// console.log(this.selectedCategId);
			// console.log(this.activeTab);
			await this.getCurrentPrograms(this.selectedCategId, this.activeTab);
		}

		if (this.showAll) {
			this.currentPrograms = [];
			this.showallsubcat = true;
			// this.getProgramsData();
			if (this.selectedCatName !== "All") {
				this.selectedsubcatName = 'All';
			}
			this.currentPrograms = this.programData;
			this.currentPrograms = this.removeDuplicates(this.currentPrograms);
		}
		this.toggleSidenav();
	}

	async onSelectSubCategInMobile(activeTab: MdbTabChange, categId: any, subcat: any, categoryName: string, catIndex: number, subcatIndex: number) {
		let desiredCatIndex = catIndex + 1;
		let desiredSubcatIndex = subcatIndex + 1;
		let catResults = this.categoryTabs.tabs._results;
		let subcatResults = this.subTabs.tabs._results;
		this.showAll = false;
		this.activeTab = activeTab;
		subcat.activeTab = this.activeTab;
		this.selectedsubcatName = subcat.name;
		this.selectedCategId = categId;
		this.showallsubcat = false;
		this.selectedCatName = categoryName;
		await this.applySubcategories();
		for (let i = 0; i < catResults.length; i += 1) {
			if (i === desiredCatIndex) {
				catResults[i]._active = true;
			} else {
				catResults[i]._active = false;
			}
		}
		for (let i = 0; i < subcatResults.length; i += 1) {
			if (i === desiredSubcatIndex) {
				subcatResults[i]._active = true;
			} else {
				subcatResults[i]._active = false;
			}
		}
		// console.log(this.categoryTabs);
		// console.log(this.subTabs);
	}

	showSubcateg(cat: any) {
		cat.showSubCategories = !cat.showSubCategories;
		if (cat.showSubCategories) {
			for (const category of this.categories) {
				if (category !== cat) {
					category.showSubCategories = false;
				}
			}
		}
	}

	async showSubcategForAll(ev: any) {
		this.showAll = true;
		this.selectedCatName = "All";
		this.selectedsubcatName = "";
		await this.applySubcategories();
		let catResults = this.categoryTabs.tabs._results;
		for (let i = 0; i < catResults.length; i += 1) {
			if (i === 0) {
				catResults[i]._active = true;
			} else {
				catResults[i]._active = false;
			}
		}
	}

	goBack() {
		// console.log('backkkk')
		this.router.navigate(['my-dashboard']);
	}

	mobileMenu() {
		this.showAll = true;
		// this.selectedsubcatName = 'All';

		// if (window.innerWidth < 800) {
		// 	this.showallsubcat = true;
		// } else {
		// 	this.showallsubcat = false;
		// }
		// console.log('this.showallsubcat ', this.showallsubcat )
	}

	isUserEnrolled(programId: string) {
		for (let enrollment of this.userEnrollments) {
			if (enrollment.programId === programId) {
				return true;
			}
		}

		return false;
	}

	getProgramProgress(programId: string) {
		for (let enrollment of this.userEnrollments) {
			if (enrollment.programId === programId) {
				return enrollment.progress;
			}
		}

		return 0;
	}

	async onClickRegister(program: any) {
		program.isRegistered = true;
		// console.log('programId', program.id);
		let data = {
			orgId: this.organizationId,
			programId: program.id,
			userId: this.userId,
			date: new Date()
		}
		// console.log(data);
		this.snackbar.open("Love your passion for learning\n" +
			"We'll keep you posted!", "", {
			duration: 3000,
			panelClass: ['interest-snackbar']
		});
		this.posthog.capture(POSTHOG_EVENT_REGISTER_INTEREST, {
			'User email': localStorage.getItem('username'),
			'Program name': program.name,
			'device_type': this.deviceDetectorService.device,
			'role': localStorage.getItem('roleId')
		});
		await this.myLibraryService.addRegisterInterestForProgram(data, '');
	}

	getRegisterInterest() {
		this.registeredPrograms = [];
		this.myLibraryService.getRegisterInterest().subscribe(data => {
			// console.log('data', data)
			this.registeredPrograms = data;
		})
	}

	hasRoleBasedAccess(programId: string) {
		const programAccess = this.orgData.programAccess;
		const roleId = localStorage.getItem("roleId") ?? "";

		if (programAccess && programAccess.length >= 1 && roleId) {
			const ele = programAccess.find((condition: any) => {
				return condition.programId === programId && condition.roleId === roleId;
			});

			if (ele && !ele.allowed) {
				return false;
			}


			return true;
		}

		return true;
	}

	sortArray(array: any) {
		array.sort((elementA: any, elementB: any) => {
			if (elementA.name < elementB.name) {
				return -1;
			} else if (elementA.name > elementB.name) {
				return 1;
			} else {
				return 0;
			}
		});
	}

	removeDuplicates(arr: any) {
		let duplicatesLessArr: any = [];

		if (arr) {
			arr.forEach((program: any) => {
				if (!this.isObjectInArray(program, duplicatesLessArr)) {
					duplicatesLessArr.push(program);
				}
			});
		}

		return duplicatesLessArr;
	}

	isObjectInArray(obj: any, arr: any) {
		for (let i = 0; i < arr.length; i += 1) {
			if (arr[i].id === obj.id) {
				return true;
			}
		}

		return false;
	}
}
